var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3525 0.34668H2.64784C1.37721 0.34668 0.347168 1.37673 0.347168 2.64735V14.352C0.347168 15.6226 1.37721 16.6527 2.64784 16.6527H14.3525C15.6231 16.6527 16.6531 15.6226 16.6531 14.352V2.64735C16.6531 1.37673 15.6231 0.34668 14.3525 0.34668Z",
    stroke: "#A9A9A9",
    strokeWidth: 0.61237,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2452 4.42773H3.75448C3.39227 4.42773 3.09863 4.72137 3.09863 5.08358V13.3285C3.09863 13.6907 3.39227 13.9844 3.75448 13.9844H13.2452C13.6074 13.9844 13.901 13.6907 13.901 13.3285V5.08358C13.901 4.72137 13.6074 4.42773 13.2452 4.42773Z",
    stroke: "#A9A9A9",
    strokeWidth: 0.61237,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76807 3.17871V5.31282M8.50189 3.17871V5.31282M12.2322 3.17871V5.31282M5.72581 9.12646L7.62743 11.0281L11.2745 7.381",
    stroke: "#A9A9A9",
    strokeWidth: 0.61237,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.f4197235b2aefabff3f90898619d2666.svg";
export { ForwardRef as ReactComponent };